import CityPageTemplate from "../city-template/CityPageTemplate";
import { wausauConfig } from "./data";

export default function WausauPage() {
  return <CityPageTemplate config={wausauConfig} />;
}